import Switch from '@material-ui/core/Switch';
import { withStyles } from '@material-ui/core/styles';

const ToggleSwitch = withStyles((theme) => ({
  root: {
    width: 40,
    height: 20,
    padding: 0,
    display: 'flex'
  },
  switchBase: {
    padding: 2,
    '&$checked': {
      transform: 'translateX(20px)',
      color: theme.palette.common.white,
      '& + $track': {
        opacity: 1,
        backgroundColor: 'rgba(0, 125, 193, 0.9)',
        borderColor: 'rgba(0, 125, 193, 0.9)'
      }
    }
  },
  thumb: {
    width: 16,
    height: 16,
    boxShadow: 'none'
  },
  track: {
    borderRadius: 24 / 2,
    opacity: 1,
    backgroundColor: '#e0e2e5'
  },
  checked: {}
}))(Switch);

export default ToggleSwitch;
